import { Injectable } from "@angular/core";
import { RoleDTO } from "../roles/Role";
import { ApiService } from "../api.service";

const PATH = "roles";

@Injectable({
  providedIn: "root",
})
export class RolesHandlerService {
  constructor(private APIService: ApiService) {}

  getRoles(masterAccountID: number, hideDeleted?: boolean) {
    return this.APIService.get(
      `${PATH}/${masterAccountID}${
        hideDeleted ? "?hide_deleted=" + hideDeleted : ""
      }`,
    );
  }

  getRole(masterAccountID: number, roleID: number) {
    return this.APIService.get(`${PATH}/${masterAccountID}/${roleID}`);
  }

  deleteRole(masterAccountID: number, roleID: number) {
    return this.APIService.delete(`${PATH}/${masterAccountID}/${roleID}`);
  }

  updateRole(masterAccountID: number, roleID: number, role: RoleDTO) {
    return this.APIService.put(`${PATH}/${masterAccountID}/${roleID}`, role);
  }

  createRole(masterAccountID: number, role: RoleDTO) {
    return this.APIService.post(`${PATH}/${masterAccountID}`, role);
  }
}
